import {Component, OnInit} from '@angular/core';
import {ApplicationService} from "../services/application.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {LoginComponent} from '../modals/login/login.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  starting = false;
  application_type: string;
  title: string;
  text: string;

  constructor(public application: ApplicationService, private modalService: NgbModal, public router: Router,
              public http: HttpClient) {
  }

  ngOnInit(): void {
  }

  public openLoginModal(type, label) {
    return this.modalService.open(LoginComponent, {size: 'md', backdrop: 'static'});
  }

  public updateApplication(type) {
    this.application.startApplication(type, true);
  };

  public login(type, label) {
    var modalInstance = this.openLoginModal(type, label);

    modalInstance.result.then(() => {
      this.router.navigate(['start', type])
    });
  };


}
